import { useCallback, useRef } from "react"

/**
 * Re-entrancy guard for handlers that create records.
 *
 * Disabling a submit button on `mutation.isPending` is not enough on its own: React Query
 * publishes the pending state on a later tick, so two clicks landing in the same frame both
 * read `isPending === false` and both fire the mutation, creating duplicates. This ref flips
 * synchronously, so the second call is rejected before it can reach `mutate`.
 *
 * Call `begin()` immediately before the mutation and bail when it returns false; release with
 * `end()` from the mutation's `onSettled`.
 */
export function useSingleFlight() {
  const inFlightRef = useRef(false)

  const begin = useCallback(() => {
    if (inFlightRef.current) return false
    inFlightRef.current = true
    return true
  }, [])

  const end = useCallback(() => {
    inFlightRef.current = false
  }, [])

  return { begin, end }
}
